import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {

  productList = [];
  loaded: boolean;
  selectedProduct: any;

  constructor(private data: DataService) { 
    this.data.getProductDB().subscribe(
      list => {
        this.productList = list.map(item => {
          return {
            $key: item.key,
            ...item.payload.val()
          }
        })

        this.loaded = true;
      }
    );
  }

  ngOnInit() {
  }

  open(product) {
    this.selectedProduct = product;
  }

}
